import React from "react";
import Navbar from "./Navbar";

export default function ENPricing() {
  return (
    <>
      <Navbar isEnglish={true} />
      
      <section className="hero">
        <div className="container">
          <div className="section-header">
            <h1>Pricing</h1>
            <p>Transparent usage-based pricing</p>
          </div>
        </div>
      </section>
      
      <section>
        <div className="container">
          <div className="pricing-intro">
            <p>TercumanApp offers a scalable pricing model that adapts to your needs. Our pricing is calculated based on the language pairs you use and the total duration.</p>
          </div>
          
          <div className="pricing-grid">
            <div className="pricing-card">
              <div className="pricing-header">
                <h3>Text Translation</h3>
                <div className="pricing-price">
                  <span className="currency">$</span>
                  <span className="amount">50</span>
                  <span className="period">/hour/language pair</span>
                </div>
                <p>Speech recognition and text translation</p>
              </div>
              <div className="pricing-features">
                <ul>
                  <li>Real-time speech recognition</li>
                  <li>Instant text translation</li>
                  <li>Automatic source language detection</li>
                  <li>Support for 50+ languages</li>
                  <li>Unlimited attendees</li>
                  <li>Pay only for language pairs you need</li>
                </ul>
              </div>
              <div className="pricing-action">
                <a href="#demo" className="cta primary">Book a Demo</a>
              </div>
            </div>
            
            <div className="pricing-card featured">
              <div className="pricing-badge">Popular</div>
              <div className="pricing-header">
                <h3>Voice Translation</h3>
                <div className="pricing-price">
                  <span className="currency">$</span>
                  <span className="amount">250</span>
                  <span className="period">/hour/language pair</span>
                </div>
                <p>Speech-to-speech translation</p>
              </div>
              <div className="pricing-features">
                <ul>
                  <li>All text translation features</li>
                  <li>Real-time speech synthesis</li>
                  <li>Natural voice narration</li>
                  <li>Gender and tone settings</li>
                  <li>Voice support in 25+ languages</li>
                  <li>High-quality neural voices</li>
                </ul>
              </div>
              <div className="pricing-action">
                <a href="#demo" className="cta primary">Book a Demo</a>
              </div>
            </div>
            
            <div className="pricing-card">
              <div className="pricing-header">
                <h3>Enterprise</h3>
                <div className="pricing-price">
                  <span className="contact">Contact Us</span>
                </div>
                <p>For custom needs and large events</p>
              </div>
              <div className="pricing-features">
                <ul>
                  <li>Volume-based discounts</li>
                  <li>Custom API integration</li>
                  <li>Personalized terminology</li>
                  <li>Custom-trained models</li>
                  <li>SLA guarantees</li>
                  <li>Dedicated account manager</li>
                </ul>
              </div>
              <div className="pricing-action">
                <a href="#contact" className="cta secondary">Contact Sales</a>
              </div>
            </div>
          </div>
          
          <div className="pricing-calculator">
            <div className="section-header">
              <h2>Price Calculator</h2>
              <p>Estimated cost for your event</p>
            </div>
            
            <div className="calculator-example">
              <h3>Example Scenarios:</h3>
              
              <div className="calculator-scenario">
                <div className="scenario-details">
                  <h4>Small Business Meeting</h4>
                  <ul>
                    <li>2 hours duration</li>
                    <li>2 language pairs (English-Turkish, English-German)</li>
                    <li>Text translation</li>
                  </ul>
                </div>
                <div className="scenario-price">
                  <p className="price">$200</p>
                  <p className="calculation">2 hours × 2 language pairs × $50</p>
                </div>
              </div>
              
              <div className="calculator-scenario">
                <div className="scenario-details">
                  <h4>International Conference</h4>
                  <ul>
                    <li>6 hours duration</li>
                    <li>3 language pairs (English-Turkish, English-French, English-Spanish)</li>
                    <li>Voice translation</li>
                  </ul>
                </div>
                <div className="scenario-price">
                  <p className="price">$4,500</p>
                  <p className="calculation">6 hours × 3 language pairs × $250</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="pricing-faq">
            <div className="section-header">
              <h2>Frequently Asked Questions</h2>
              <p>Answers to common questions about our pricing</p>
            </div>
            
            <div className="faq-grid">
              <div className="faq-item">
                <h3>What is a "language pair"?</h3>
                <p>A language pair refers to translation from one source language to one target language. For example, English-Turkish is one language pair.</p>
              </div>
              
              <div className="faq-item">
                <h3>How am I billed?</h3>
                <p>Payment is made upfront for your event. The cost is calculated based on the duration and number of language pairs used in the event.</p>
              </div>
              
              <div className="faq-item">
                <h3>Can I get a refund for unused time?</h3>
                <p>Yes, we provide prorated refunds for unused time. Refund requests are processed within 7 days after the end of your event.</p>
              </div>
              
              <div className="faq-item">
                <h3>What is automatic source language detection?</h3>
                <p>The system automatically detects the language being spoken and translates accordingly. This eliminates the need for manual switching for speakers using multiple languages.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="cta-section">
        <div className="container">
          <h2>Let's Discuss Your Needs</h2>
          <p>Contact us for custom pricing tailored to your event.</p>
          <div className="cta-buttons">
            <a href="#contact" className="cta primary">Contact Us</a>
            <a href="#demo" className="cta secondary">Book a Demo</a>
          </div>
        </div>
      </section>
    </>
  );
}
